module.exports = __webpack_public_path__ + "static/media/Data_insight_en_mo_3-3.a0668abd.svg";